import { render, staticRenderFns } from "./AppointmentSelectClinic.vue?vue&type=template&id=5fca0e70&"
import script from "./AppointmentSelectClinic.vue?vue&type=script&lang=js&"
export * from "./AppointmentSelectClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports